import { createContext, useReducer, useContext, Dispatch, ReactNode } from 'react';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';

interface DP3State {
    timeLine: any;
    pageStatus: IPageStatus;
}

type DP3Action = {
    type: string;
    payload: any;
};

const initState: DP3State = {
    pageStatus: IPageStatus.statusA,
    timeLine: null,
};

const fsReducer = (state: DP3State, action: DP3Action): DP3State => {
    const { type, payload } = action;
    switch (type) {
        case 'changePageStatus':
            return { ...state, pageStatus: payload };
        default:
            return state;
    }
};

export const DP3Context = createContext<{ state: DP3State; dispatch: Dispatch<DP3Action> }>({
    state: initState,
    dispatch: () => null,
});

export function DP3Provider({ children, ...props }: { children: ReactNode; state?: any }) {
    const [state, dispatch] = useReducer(fsReducer, Object.assign(initState, props.state || {}));
    return <DP3Context.Provider value={{ state, dispatch }}>{children}</DP3Context.Provider>;
}

export const useDP3Store = () => {
    const store = useContext(DP3Context);
    return store.state;
};

export const useDP3Dispatch = () => {
    const store = useContext(DP3Context);
    return store.dispatch;
};
